module.exports = __webpack_public_path__ + "img/client_personalized.30ae5132.jpg";